/**
 * Flag Icon Library - Lightweight SVG icon set for custom flags
 * All icons use viewBox "0 0 20 20" to match existing icon style
 */

export const FLAG_ICONS = {
  // Priority/Status Icons
  check: {
    path: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    viewBox: "0 0 20 20"
  },
  warning: {
    path: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    viewBox: "0 0 20 20"
  },
  exclamation: {
    path: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    viewBox: "0 0 20 20"
  },
  star: {
    path: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
    viewBox: "0 0 20 20"
  },
  flag: {
    path: "M3 3a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V3zm0 4a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H4a1 1 0 01-1-1V7zm10-1a1 1 0 011 1v2a1 1 0 11-2 0V7a1 1 0 011-1z",
    viewBox: "0 0 20 20"
  },
  
  // Time/Date Icons
  clock: {
    path: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
    viewBox: "0 0 20 20"
  },
  calendar: {
    path: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
    viewBox: "0 0 20 20"
  },
  hourglass: {
    path: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z",
    viewBox: "0 0 20 20"
  },
  
  // People/Guest Icons
  user: {
    path: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
    viewBox: "0 0 20 20"
  },
  users: {
    path: "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z",
    viewBox: "0 0 20 20"
  },
  heart: {
    path: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
    viewBox: "0 0 20 20"
  },
  
  // Location/Property Icons
  home: {
    path: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z",
    viewBox: "0 0 20 20"
  },
  'map-pin': {
    path: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
    viewBox: "0 0 20 20"
  },
  key: {
    path: "M18 8a2 2 0 01-2 2h-1.464a1.535 1.535 0 01-2.768 0H8a2 2 0 01-2-2V6a2 2 0 012-2h3.768a1.535 1.535 0 012.768 0H16a2 2 0 012 2v2zM5 9a1 1 0 100-2 1 1 0 000 2zm9-1a1 1 0 11-2 0 1 1 0 012 0z",
    viewBox: "0 0 20 20"
  },
  
  // Action/Status Icons
  bell: {
    path: "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z",
    viewBox: "0 0 20 20"
  },
  info: {
    path: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    viewBox: "0 0 20 20"
  },
  lock: {
    path: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
    viewBox: "0 0 20 20"
  },
  unlock: {
    path: "M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z",
    viewBox: "0 0 20 20"
  },
  tag: {
    path: "M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z",
    viewBox: "0 0 20 20"
  },
  bookmark: {
    path: "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z",
    viewBox: "0 0 20 20"
  },
  shield: {
    path: "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    viewBox: "0 0 20 20"
  },
  tools: {
    path: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
    viewBox: "0 0 20 20"
  },
  sparkles: {
    path: "M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z",
    viewBox: "0 0 20 20"
  },
  
  // Plus/Minus
  plus: {
    path: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
    viewBox: "0 0 20 20"
  },
  minus: {
    path: "M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
    viewBox: "0 0 20 20"
  }
};

/**
 * Get all available icon names
 */
export const getIconNames = () => Object.keys(FLAG_ICONS);

/**
 * Check if an icon exists
 */
export const hasIcon = (iconName) => {
  return iconName && FLAG_ICONS.hasOwnProperty(iconName);
};

/**
 * React component to render a flag icon
 * @param {string} iconName - Name of the icon to render
 * @param {string} className - CSS classes (default matches existing icon style)
 * @param {string} color - Fill color (default: currentColor)
 */
export const FlagIcon = ({ iconName, className = "h-3 w-3 sm:h-4 sm:w-4 mr-1", color = "currentColor" }) => {
  if (!iconName) {
    return null;
  }
  
  // Case-insensitive lookup
  const normalizedIconName = iconName.toLowerCase().trim();
  const iconKey = Object.keys(FLAG_ICONS).find(key => key.toLowerCase() === normalizedIconName);
  const icon = iconKey ? FLAG_ICONS[iconKey] : FLAG_ICONS[iconName];
  
  if (!icon) {
    // Fallback to a default icon if not found
    return (
      <svg 
        className={className} 
        viewBox="0 0 20 20" 
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        style={{ 
          color: color,
          display: 'inline-block',
          verticalAlign: 'middle',
          flexShrink: 0
        }}
      >
        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
      </svg>
    );
  }
  
  return (
    <svg 
      className={className} 
      viewBox={icon.viewBox || "0 0 20 20"} 
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ 
        color: color,
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0
      }}
    >
      <path fillRule="evenodd" d={icon.path} clipRule="evenodd" />
    </svg>
  );
};

